/**
 * description: CA签字保存
 * author: bql
 * 2023/5/15 16:12
 */
import {SmartSiteBaseApiV2} from "../SmartSiteBaseApiV2";
import {Methods} from "@newview/infrastructure";

export class CaSignatureApi extends SmartSiteBaseApiV2 {

    public get ControllerName(): any {
        return 'ca-signature';
    }

    /**
     * 删除ca签字
     * @param CACode
     */
    public deleteByCACode(CACode){
        return this.send({CACode:CACode},"deleteByCACode",Methods.GET)
    }


    /**
     * 删除ca签字
     * @param CACode
     */
    public deleteByCACodeAndFlowStep(CACode, FlowStep){
        return this.send({CACode:CACode,FlowStep:FlowStep},"deleteByCACode",Methods.GET)
    }

}
 